import React, { useState } from 'react';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
import _ from 'lodash';
import { useTableApi } from '~Components/TableUniverse';
import SelectOptionModal from '~Components/SelectOptionModal';
import State from '~Types/state';
import { useSelector, useI18n, useButton } from '~Hooks';
import PaymentStatus from '~Components/PaymentStatus';
import { range } from 'lodash';
import useModal from '~ComponentsImproved/Modal/useModal';
import DemoNoPaymentsAllowed from '~Components/DemoHandler/NoPaymentsAllowed';
import PayButtons from '~Scenes/Tables/Components/PayButtons';
import { WhiteButton } from '~Styles';
import DiscountButton from '~Components/DiscountButton';

const Wrapper = styled.div`
  z-index: 2;
`;

const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 8px;

  > button,
  > div {
    min-width: calc(50% - 4px);
  }
`;
interface Props {
  tableName: string;
  tableId: string;
  selectedCheque: string | null;
  selectedItems: string[];
  clearSelectedItems: () => void;
  hasPartialPayment?: boolean;
}

const Payment: React.FunctionComponent<Props> = ({
  tableName,
  tableId,
  selectedCheque,
  selectedItems,
  clearSelectedItems,
  hasPartialPayment,
}) => {
  const [isSplittingCheque, setIsSplittingCheque] = useState(false);
  const api = useTableApi();
  const { i18n } = useI18n();

  const demoPopup = useModal();

  const order = useSelector((state) =>
    state.POSOrders.find((order) => order.chequeId === selectedCheque),
  );

  const payment = useSelector((state) =>
    state.POSPayments.find((payment) => payment.order === order?.id),
  );

  const splitButton = useButton({
    onClick: () => setIsSplittingCheque(true),
    disabled: hasPartialPayment,
    disabledToast: i18n('TM.SplitPartialDisabled'),
  });

  return (
    <Wrapper>
      {payment ? (
        <PaymentStatus status={payment.status} paymentId={payment.id} />
      ) : (
        <div>
          <ButtonRow>
            <WhiteButton data-testid="split-cheque" {...splitButton} fluid>
              {i18n('TM.Split')}
            </WhiteButton>
            <DiscountButton
              selectedItemIds={selectedItems}
              onComplete={() => {
                clearSelectedItems();
              }}
              selectedChequeId={selectedCheque || undefined}
            />
          </ButtonRow>
          <PayButtons
            selectedTable={{
              id: tableId,
              code: tableName,
            }}
            selectedChequeId={selectedCheque || undefined}
          />
        </div>
      )}
      {isSplittingCheque && (
        <SelectOptionModal
          enableCustomInput
          title={i18n('TM.Split')}
          options={range(2, 9)}
          onSelect={(count) => {
            const ids = api.splitCheque(selectedCheque!, count as number);
            api.log.splitCheque(selectedCheque!, ids);
            setIsSplittingCheque(false);
          }}
          onCancel={() => setIsSplittingCheque(false)}
        />
      )}
      <DemoNoPaymentsAllowed isShowing={demoPopup.isShowing} toggle={demoPopup.toggle} />
    </Wrapper>
  );
};

const mapStateToProps = (state: State) => ({
  paymentMethods: state.POSPaymentMethods,
});

export default connect(mapStateToProps)(Payment);
